import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { NextActionModalCard } from './NextActionModalCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NextActionModalBody = ({
  description,
  card,
  progressPercentage,
  trackingProperties
}) => {
  return /*#__PURE__*/_jsx(DialogBody, {
    paddingBlock: "1000",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      children: [description && /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "50",
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          children: description
        })
      }), progressPercentage !== undefined && /*#__PURE__*/_jsx(Progress, {
        "aria-label": "Task progress",
        use: "success",
        value: progressPercentage,
        hasLabel: true
      }), card && /*#__PURE__*/_jsx(NextActionModalCard, Object.assign({}, card, {
        trackingProperties: trackingProperties
      }))]
    })
  });
};